export const Z_INDEX_SELECT = { zIndex: 10 };
export const INIT_HEIGHT = 200;
const SMALL_AREA_HEIGHT = 300;
const MAX_MENU_HEIGHT_REGULAR = 200;
const MAX_MENU_HEIGHT_SMALL_AREA = 50;

export const calculateMaxMenuHeight = (height: number): number => {
    return height < SMALL_AREA_HEIGHT ? MAX_MENU_HEIGHT_SMALL_AREA : MAX_MENU_HEIGHT_REGULAR;
};
